// extracted by mini-css-extract-plugin
module.exports = {"requirements-container":"PasswordRequirements_requirements-container__xDoCX","requirements-row":"PasswordRequirements_requirements-row__xjulB"};